import type {
  GetBankCodeListQueryVariables,
  GetRefundableAmountQueryVariables,
  VerifyBankAccountQueryVariables,
} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Billing 도메인 Query Key 관리
 */
export const BILLING_QUERY_KEY_MAP = {
  /**
   * 은행 코드 목록 조회
   * Origin: useGetBankCodeListQuery.getKey
   */
  bankCodeList: (variables?: GetBankCodeListQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'getBankCodeList'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'getBankCodeList', variables] as const),
  /**
   * 환불 가능 잔액 조회
   * Origin: useGetRefundableAmountQuery.getKey
   */
  refundableAmount: (variables?: GetRefundableAmountQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'getRefundableAmount'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'getRefundableAmount', variables] as const),
  /**
   * 계좌 인증
   * Origin: useVerifyBankAccountQuery.getKey
   */
  verifyBankAccount: (variables: VerifyBankAccountQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'verifyBankAccount', variables] as const,
} as const;

/**
 * Billing 도메인 Mutation Key 관리
 */
export const BILLING_MUTATION_KEY_MAP = {
  /**
   * 환불 요청
   * Origin: useRequestCreditRefundMutation (getKey 없음)
   */
  requestCreditRefund: 'requestCreditRefund',
} as const;
